import { useSelector, useDispatch } from "react-redux";
import BaseHeading from "../../../../baseComponents/baseHeading.js";
import BaseParagraph from "../../../../baseComponents/baseParagraph.js";
import useBootstrap from "../../../../customHooks/useBootstrap.js";
import useRewards from "../../../../customHooks/useRewards.js";
import { Container, Row, Col } from "reactstrap";


const MyRewardsTier = ({}) => {
  const dispatch = useDispatch();
  const tierRewards = useRewards().tierRewards;
  const systemState = useSelector((state) => state.systemState);

  const { trashold9, classes } = useBootstrap();



  return (
    <div>
      <Container fluid className={`p-0 ${classes.onOrAboveTrashold.marginTop(true,4)}`}>
        <Row>
          <Col {...trashold9}>
            {tierRewards.map((reward) => {
              
              return (
                <div key={reward.promotion_id}>
                  <div style={{ display: "flex" }}>
                    <span
                      style={{
                        flex: 2,
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "0px"
                      }}
                    >
                      <span style = {{marginBottom: "10px"}}>
                        <BaseHeading>{reward.promotion_name}</BaseHeading>
                      </span>
                      <span>
                        <BaseParagraph>
                          {reward.promotion_description}
                        </BaseParagraph>
                      </span>
                    </span>
                    <span
                      style={{
                        flex: 1,
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span
                        style={{  textAlign: "right" }}
                      >{`${reward.discountText}${
                        reward.showCurrency
                          ? " " + systemState.settings.currency
                          : ""
                      }`}</span>
                    </span>

                    {/* <BaseHeading>{reward.promotion_name}</BaseHeading>
                  <br />
                  <BaseParagraph>{reward.promotion_description}</BaseParagraph>
                  <br />
                  <br /> */}
                  </div>
                  <br />
                </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MyRewardsTier;

{
  /* <Row>
          {userState.rewards.cupons.map((cupon) => {
            return (
              <Reward
                key={cupon.promotion_id}
                name={cupon.promotion_name}
                description={cupon.promotion_description}
              />
            );
          })}
          <Reward />
        </Row> */
}
